import { pushEvent } from "utils/data-layer"

const EXPERIMENT_EXPOSURE_EVENT = "experiment_exposure"
const EXPERIMENT_INTERACTION_EVENT = "experiment_interaction"

export interface ExperimentAnalyticsParams {
  experimentId: string
  experimentVariant: string
}

interface ExperimentInteractionParams extends ExperimentAnalyticsParams {
  experimentAction: string
}

function pushExperimentEvent(
  event: string,
  experimentId: string,
  experimentVariant: string,
  params: Record<string, unknown> = {},
): void {
  pushEvent(event, {
    experiment_id: experimentId,
    experiment_variant: experimentVariant,
    ...params,
  })
}

export function experimentParamsFromElement(
  element: HTMLElement,
  fallback: ExperimentAnalyticsParams,
): ExperimentAnalyticsParams {
  return {
    experimentId: element.dataset.experimentId || fallback.experimentId,
    experimentVariant: element.dataset.experimentVariant || fallback.experimentVariant,
  }
}

export function trackExperimentExposure({
  experimentId,
  experimentVariant,
}: ExperimentAnalyticsParams): void {
  pushExperimentEvent(EXPERIMENT_EXPOSURE_EVENT, experimentId, experimentVariant)
}

export function trackExperimentInteraction({
  experimentId,
  experimentVariant,
  experimentAction,
}: ExperimentInteractionParams): void {
  pushExperimentEvent(EXPERIMENT_INTERACTION_EVENT, experimentId, experimentVariant, {
    experiment_action: experimentAction,
  })
}
